if (!customElements.get('product-addons-source')) {
  customElements.define('product-addons-source', class extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(() => this.mount());
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.onEditorSelect = event => {
        if (!this.mounted?.contains(event.target)) return;
        const accordion = event.target.closest('[data-nested-addon-accordion]');
        const addon = accordion?.querySelector('printer-filament-addon');
        if (addon?.initialized && addon.panel.hidden) addon.togglePanel();
      };
      document.addEventListener('shopify:block:select', this.onEditorSelect);
      this.mount();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('shopify:block:select', this.onEditorSelect);
      this.mounted?.remove();
      this.mounted = null;
    }

    mount() {
      const target = document.querySelector(`[data-nested-addons-target][data-product-id="${this.dataset.productId}"]`);
      if (!target || this.mounted?.parentElement === target) return;
      if (!this.mounted) {
        const source = this.querySelector('[data-addon-section-template]');
        if (!source) return;
        this.mounted = document.createElement('div');
        this.mounted.className = 'printer-addon-groups';
        this.mounted.dataset.addonSectionId = this.dataset.sectionId;
        this.mounted.append(source.content.cloneNode(true));
        const usedProducts = new Set();
        this.mounted.querySelectorAll('[data-nested-addon-accordion]').forEach(accordion => {
          let winner = null;
          let score = 0;
          accordion.querySelectorAll('[data-nested-addon-profile]').forEach(profile => {
            if (Number(profile.dataset.matchScore) > score) {
              score = Number(profile.dataset.matchScore);
              winner = profile;
            }
          });
          if (!winner) { accordion.hidden = true; return; }
          const fragment = winner.querySelector('template').content.cloneNode(true);
          fragment.querySelectorAll('script, link').forEach(node => node.remove());
          const addon = fragment.querySelector('printer-filament-addon');
          if (!addon) { accordion.hidden = true; return; }
          addon.querySelectorAll('[data-addon-product]').forEach(card => {
            if (usedProducts.has(card.dataset.addonProductId)) card.remove();
            else usedProducts.add(card.dataset.addonProductId);
          });
          if (!addon.querySelector('[data-addon-product]')) { accordion.hidden = true; return; }
          const cards = [...addon.querySelectorAll('[data-addon-product]')];
          const visibleCount = Number(addon.dataset.visibleCount) || 2;
          cards.forEach((card, index) => {
            card.toggleAttribute('data-addon-extra', index >= visibleCount);
            card.hidden = index >= visibleCount;
          });
          const viewAll = addon.querySelector('[data-addon-view-all]');
          if (viewAll) viewAll.hidden = cards.length <= visibleCount;
          const heading = accordion.dataset.heading || 'Add Extras';
          addon.querySelector('.printer-filament-addon__trigger-copy strong').textContent = heading;
          addon.querySelector('[data-addon-toggle]').setAttribute('aria-label', heading);
          const badge = addon.querySelector('.printer-filament-addon__badge') || document.createElement('span');
          badge.className = 'printer-filament-addon__badge';
          const automatic = addon.dataset.pricingMode === 'shopify_quote';
          badge.toggleAttribute('data-quote-badge', automatic);
          badge.toggleAttribute('data-manual-badge', !automatic);
          badge.textContent = automatic ? '' : (accordion.dataset.badgeText || '').trim();
          badge.hidden = !badge.textContent;
          if (!badge.parentElement) addon.querySelector('.printer-filament-addon__trigger-copy strong').after(badge);
          winner.hidden = false;
          winner.append(fragment);
        });
      }
      target.append(this.mounted);
      if (this.mounted.querySelector('printer-filament-addon')) {
        import(this.dataset.moduleUrl).catch(error => {
          this.mounted?.remove();
          this.mounted = null;
          this.observer.disconnect();
          console.error('Product add-ons could not initialize', error);
        });
      }
    }
  });
}
